import { createTheme } from "@mantine/core"

export const theme = createTheme({
    primaryColor: "mindvault",
    colors: {
        mindvault: [
            "#f7f2ea",
            "#ece3d7",
            "#dbc9b4",
            "#c7ac8e",
            "#b4936f",
            "#a7815c",
            "#8a6a4a",
            "#715539",
            "#5b432c",
            "#3f2f20",
        ],
    },
})
